/* @generated */

// ../src/text_fields/select/select.tsx
import * as React6 from "react";
import classNames3 from "classnames";

// ../src/text_fields/select/option.tsx
import * as React2 from "react";
import { Menu } from "@dropbox/dig-components/menu";

// ../src/text_fields/select/context.tsx
import * as React from "react";
var defaultValue = {
  isNative: false,
  selectedItem: { value: "", label: "", activeID: "", accessory: null },
  setActiveValue: () => false,
  isControlled: false,
  selectId: ""
};
var SelectContext = React.createContext(defaultValue);

// ../src/text_fields/select/option.tsx
var NativeOption = ({
  className: _className,
  withAccessory: _withAccessory,
  ...props
}) => /* @__PURE__ */ React2.createElement("option", { ...props });
var CustomOption = ({ value, withAccessory, ...rest }) => {
  const { selectedItem, selectId } = React2.useContext(SelectContext);
  const isSelected = selectedItem.value === value;
  return /* @__PURE__ */ React2.createElement(
    Menu.SelectItem,
    {
      role: "option",
      id: `${selectId}-${value}`,
      "aria-selected": isSelected,
      selected: isSelected,
      withRightAccessory: withAccessory,
      value,
      ...rest
    }
  );
};
var Option = ({ ...rest }) => {
  const { isNative } = React2.useContext(SelectContext);
  const Option2 = isNative ? NativeOption : CustomOption;
  return /* @__PURE__ */ React2.createElement(Option2, { ...rest });
};
Option.displayName = "Option";

// ../src/text_fields/select/optgroup.tsx
import * as React3 from "react";
import { Menu as Menu2 } from "@dropbox/dig-components/menu";
var OptGroup = ({ withLabel, children }) => {
  const { isNative } = React3.useContext(SelectContext);
  let nativeProps = {};
  if (withLabel && isNative) {
    nativeProps = { label: withLabel };
  }
  return isNative ? /* @__PURE__ */ React3.createElement("optgroup", { ...nativeProps }, children) : /* @__PURE__ */ React3.createElement(Menu2.Segment, { withLabel }, children);
};
OptGroup.displayName = "OptGroup";

// ../src/text_fields/select/trigger_native.tsx
import * as React4 from "react";
import classNames from "classnames";
import { UIIcon } from "@dropbox/dig-icons";
import { ChevronDownLine } from "@dropbox/dig-icons/assets";

// ../src/text_fields/select/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var nativeActiveSelect = "dig-1mw157mb_22-5-0";
var selectIconRecipe = _7a468({ defaultClassName: "dig-1mw157md_22-5-0", variantClassNames: { hasPlaceholder: { true: "dig-1mw157me_22-5-0" }, isInvalid: { true: "dig-1mw157mf_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var selectMenu = "dig-1mw157mp_22-5-0";
var selectRecipe = _7a468({ defaultClassName: "dig-1mw157m2_22-5-0 dig-1mw157m1_22-5-0", variantClassNames: { disabled: { true: "dig-1mw157m3_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var selectTriggerAccessoryWrapperRecipe = _7a468({ defaultClassName: "dig-1mw157mk_22-5-0", variantClassNames: { size: { small: "dig-1mw157ml_22-5-0", medium: "dig-1mw157mm_22-5-0", large: "dig-1mw157mn_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var selectTriggerContent = "dig-1mw157mc_22-5-0";
var selectTriggerIconRecipe = _7a468({ defaultClassName: "dig-1mw157mg_22-5-0", variantClassNames: { size: { small: "dig-1mw157mh_22-5-0", medium: "dig-1mw157mi_22-5-0", large: "dig-1mw157mj_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var selectTriggerLabel = "dig-1mw157mo_22-5-0";
var selectTriggerRecipe = _7a468({ defaultClassName: "dig-1mw157m4_22-5-0 dig-1mw157m1_22-5-0", variantClassNames: { size: { small: "dig-1mw157m5_22-5-0", medium: "dig-1mw157m6_22-5-0", large: "dig-1mw157m7_22-5-0" }, hasPlaceholder: { true: "dig-1mw157m8_22-5-0" }, isInvalid: { true: "dig-1mw157m9_22-5-0" }, isNative: { true: "dig-1mw157ma_22-5-0" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });

// ../src/_global/sizes.tsx
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getLegacyComponentSize = (size) => {
  const mapping = deprecationMap.find(([newVal, _deprecatedVal]) => size === newVal);
  if (mapping !== void 0) {
    return mapping[1];
  }
  return size;
};
var getMigratedComponentSize = (size) => {
  const mapping = deprecationMap.find(([_newVal, deprecatedVal]) => size === deprecatedVal);
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/text_fields/select/trigger_native.tsx
var SelectTriggerNative = ({
  children,
  placeholder,
  className,
  disabled,
  onChange,
  size: _size,
  inverse: _inverse,
  isInvalid: _isInvalid,
  isNative: _isNative,
  ...rest
}) => {
  const { selectedItem, setActiveValue, isControlled } = React4.useContext(SelectContext);
  const [empty, setEmpty] = React4.useState(!selectedItem.value);
  const handleChange = (e) => {
    const elm = e.currentTarget;
    const newValue = elm.value;
    if (!isControlled) {
      setActiveValue(newValue);
    }
    if (onChange) onChange(newValue, e);
  };
  React4.useEffect(() => {
    setEmpty(!selectedItem.value);
  }, [selectedItem.value]);
  return /* @__PURE__ */ React4.createElement(
    "span",
    {
      className: classNames(className, "dig-Select--native", {
        "dig-Select--isActive": !empty,
        [nativeActiveSelect]: !empty
      })
    },
    /* @__PURE__ */ React4.createElement(
      "select",
      {
        className: classNames(
          "dig-Select-trigger",
          {
            "dig-Select-trigger--hasPlaceholder": !!placeholder && empty
          },
          selectTriggerRecipe({
            size: getMigratedComponentSize(_size || "medium"),
            hasPlaceholder: !!placeholder && empty,
            isInvalid: !!_isInvalid,
            isNative: true
          })
        ),
        disabled,
        onChange: handleChange,
        value: selectedItem.value,
        ...rest
      },
      placeholder && /* @__PURE__ */ React4.createElement("option", { value: "", disabled: rest.required }, placeholder),
      children
    ),
    /* @__PURE__ */ React4.createElement(
      UIIcon,
      {
        src: ChevronDownLine,
        isOpticallyAligned: true,
        className: classNames(
          "dig-Select-icon",
          selectIconRecipe({
            hasPlaceholder: !!placeholder && empty,
            isInvalid: !!rest["aria-invalid"]
          })
        ),
        size: "small"
      }
    )
  );
};

// ../src/text_fields/select/trigger_custom.tsx
import classNames2 from "classnames";
import * as React5 from "react";
import { Menu as Menu3 } from "@dropbox/dig-components/menu";
import { UIIcon as UIIcon2 } from "@dropbox/dig-icons";
import { ChevronDownLine as ChevronDownLine2 } from "@dropbox/dig-icons/assets";
var SelectTriggerCustom = ({
  onChange,
  placeholder,
  children,
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  defaultValue: defaultValue2,
  disabled,
  value,
  id,
  inverse: _inverse,
  triggerType = "button",
  withLeftAccessory,
  shouldShowOptionAccessory = true,
  size,
  name,
  onToggle,
  open,
  ...rest
}) => {
  const { setActiveValue, selectedItem, isControlled } = React5.useContext(SelectContext);
  const handleChange = (val, event) => {
    if (!isControlled) {
      setActiveValue(val);
    }
    if (onChange) onChange(val, event);
  };
  const hasPlaceholder = !!placeholder && !value && !selectedItem.value;
  return /* @__PURE__ */ React5.createElement(
    Menu3.Wrapper,
    {
      className,
      onSelection: handleChange,
      matchContainingWidth: true,
      shouldFocusDisabledRows: false,
      isBlock: true,
      onToggle
    },
    ({ getContentProps, getTriggerProps }) => {
      const contentProps = getContentProps({});
      const isOpen = open !== void 0 ? open : contentProps.open;
      const triggerProps = !disabled ? getTriggerProps() : {};
      return /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(
        "input",
        {
          type: "hidden",
          value: selectedItem.value,
          name,
          "data-testid": "DigCustomSelectHiddenInput"
        }
      ), /* @__PURE__ */ React5.createElement(
        "button",
        {
          className: classNames2(
            "dig-Select-trigger",
            {
              "dig-Select-trigger--hasPlaceholder": hasPlaceholder
            },
            selectTriggerRecipe({
              size: getMigratedComponentSize(size || "medium"),
              hasPlaceholder,
              isInvalid: !!rest["aria-invalid"]
            })
          ),
          role: "combobox",
          "aria-activedescendant": `${selectedItem.activeID}`,
          "aria-autocomplete": "none",
          "aria-haspopup": "listbox",
          "aria-controls": `${id}-listbox`,
          "aria-label": rest["aria-label"],
          "aria-invalid": rest["aria-invalid"],
          "data-testid": rest["data-testid"],
          id,
          disabled,
          type: triggerType,
          ...triggerProps
        },
        /* @__PURE__ */ React5.createElement("span", { className: classNames2("dig-Select-trigger__content", selectTriggerContent) }, shouldShowOptionAccessory && selectedItem.accessory || !shouldShowOptionAccessory && withLeftAccessory ? /* @__PURE__ */ React5.createElement(
          "span",
          {
            className: classNames2(
              "dig-Select-trigger--withAccessory",
              selectTriggerAccessoryWrapperRecipe({
                size: getMigratedComponentSize(size || "medium")
              })
            )
          },
          /* @__PURE__ */ React5.createElement(
            "span",
            {
              className: classNames2(
                "dig-Select-trigger-icon",
                selectTriggerIconRecipe({ size: getMigratedComponentSize(size || "medium") })
              )
            },
            React5.cloneElement(
              shouldShowOptionAccessory ? selectedItem.accessory : withLeftAccessory,
              { size }
            )
          ),
          /* @__PURE__ */ React5.createElement("span", { className: classNames2("dig-Select-trigger-label", selectTriggerLabel) }, selectedItem.label || placeholder)
        ) : selectedItem.label || placeholder),
        /* @__PURE__ */ React5.createElement(
          UIIcon2,
          {
            src: ChevronDownLine2,
            isOpticallyAligned: true,
            className: classNames2(
              "dig-Select-icon",
              selectIconRecipe({ hasPlaceholder, isInvalid: !!rest["aria-invalid"] })
            ),
            size: "small"
          }
        )
      ), /* @__PURE__ */ React5.createElement(Menu3.Content, { ...contentProps, open: isOpen }, /* @__PURE__ */ React5.createElement(
        Menu3.Segment,
        {
          _withoutPadding: true,
          role: "listbox",
          id: `${id}-listbox`,
          className: classNames2("dig-Select-menu", selectMenu)
        },
        children
      )));
    }
  );
};

// ../src/text_fields/utils.ts
var combineInvalid = (isInvalid, ariaInvalid) => {
  if (ariaInvalid !== void 0) {
    return ariaInvalid;
  } else {
    return isInvalid;
  }
};

// ../src/text_fields/select/select.tsx
import { ThemeProvider, useTheme } from "@dropbox/dig-foundations";
var selectedItemDefault = {
  value: "",
  label: "",
  accessory: null,
  activeID: ""
};
var Select = ({
  children,
  size: _size = "medium",
  value,
  defaultValue: defaultValue2,
  isNative = false,
  transformDisplayValue,
  isInvalid,
  "aria-invalid": ariaInvalid,
  selectRef,
  inverse,
  ...rest
}) => {
  const size = getMigratedComponentSize(_size);
  const fusionInvalid = combineInvalid(isInvalid, ariaInvalid);
  const cls2 = classNames3(
    "dig-Select",
    `dig-Select--${getLegacyComponentSize(size)}`,
    {
      "dig-Select--medium": size === "medium",
      "dig-Select--isInvalid": !!isInvalid && !rest.disabled,
      "dig-Select--disabled": rest.disabled
    },
    selectRecipe({ disabled: !!rest.disabled })
  );
  const SelectTrigger = isNative ? SelectTriggerNative : SelectTriggerCustom;
  const [selectedItem, setSelectedItem] = React6.useState(selectedItemDefault);
  React6.useImperativeHandle(
    selectRef,
    () => ({
      reset: () => {
        setSelectedItem(selectedItemDefault);
      }
    }),
    [setSelectedItem]
  );
  const items = React6.useMemo(() => {
    const itemArray = [];
    React6.Children.forEach(children, (child) => {
      if (!React6.isValidElement(child)) {
        return null;
      }
      if (child.type === React6.Fragment) {
        throw new Error(
          [
            "dig-components: The Select component doesn't accept a Fragment as a child.",
            "Consider providing an array instead."
          ].join("\n")
        );
      }
      if (child.type === OptGroup) {
        React6.Children.toArray(child.props.children).forEach((propChild) => {
          if (React6.isValidElement(propChild)) {
            itemArray.push(propChild);
          }
        });
      } else {
        itemArray.push(child);
      }
    });
    return itemArray;
  }, [children]);
  const handleChange = React6.useCallback(
    (value2) => {
      const optChild = items.find((i) => i.props.value === value2);
      if (optChild) {
        const label = transformDisplayValue ? transformDisplayValue(value2) : optChild.props.children;
        setSelectedItem({
          value: optChild.props.value,
          label,
          accessory: optChild.props.withAccessory,
          activeID: `${rest.id}-${optChild.props.value}`
        });
      }
    },
    [rest.id, items, transformDisplayValue]
  );
  React6.useEffect(() => {
    const searchFor = value || defaultValue2;
    if (searchFor) {
      handleChange(searchFor);
    }
  }, [value, defaultValue2, handleChange]);
  const providedValues = {
    isNative,
    selectedItem,
    setActiveValue: handleChange,
    isControlled: !!value,
    selectId: rest.id
  };
  const selectContent = /* @__PURE__ */ React6.createElement(SelectContext.Provider, { value: providedValues }, /* @__PURE__ */ React6.createElement(SelectTrigger, { size, "aria-invalid": fusionInvalid, ...rest, className: cls2 }, children));
  const currentMode = useTheme().mode;
  if (inverse) {
    const newMode = currentMode === "bright" ? "dark" : "bright";
    return /* @__PURE__ */ React6.createElement(ThemeProvider, { mode: newMode }, ({ getThemeProps }) => {
      return /* @__PURE__ */ React6.createElement("div", { ...getThemeProps() }, selectContent);
    });
  }
  return selectContent;
};
Select.displayName = "Select";
Select.Option = Option;
Select.OptGroup = OptGroup;

// ../src/text_fields/text_area.tsx
import classNames4 from "classnames";
import * as React7 from "react";

// ../src/_global/createAttachRef.tsx
var createAttachRef = (ref, innerRef) => {
  return (el) => {
    innerRef.current = el;
    if (ref) {
      if (typeof ref === "function") {
        ref(el);
      } else {
        ref.current = el;
      }
    }
  };
};

// ../src/text_fields/text_area.tsx
import { useResizeObserver } from "@react-hookz/web";
import { useTheme as useTheme2, makeScrollbarClassName } from "@dropbox/dig-foundations";
import cls from "classnames";

// ../src/text_fields/index.css.ts
import { createRuntimeFn as _7a4682 } from "@vanilla-extract/recipes/createRuntimeFn";
var sizeMapToBorderRadius = { small: "Small", medium: "Medium", large: "Large" };
var textAreaFieldSizing = "dig-40uuazr_22-5-0";
var textAreaMaxRowsStyle = "dig-40uuazs_22-5-0";
var textAreaMaxRowsVar = "var(--dig-40uuazc_22-5-0)";
var textAreaPaddingBottom = 5;
var textAreaPaddingTop = 6;
var textAreaRecipe = _7a4682({ defaultClassName: "dig-40uuazd_22-5-0 dig-40uuaz3_22-5-0", variantClassNames: { size: { large: "dig-40uuaze_22-5-0", medium: "dig-40uuazf_22-5-0", small: "dig-40uuazg_22-5-0" }, resizable: { auto: "dig-40uuazh_22-5-0", horizontal: "dig-40uuazi_22-5-0", vertical: "dig-40uuazj_22-5-0", both: "dig-40uuazk_22-5-0" }, isInvalid: { true: "dig-40uuazl_22-5-0" }, variant: { standard: "dig-40uuazm_22-5-0", transparent: "dig-40uuazn_22-5-0", unstyled: "dig-40uuazo_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var textInputAccessoryRecipe = _7a4682({ defaultClassName: "dig-40uuazt_22-5-0", variantClassNames: { position: { start: "dig-40uuazu_22-5-0", end: "dig-40uuazv_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var textInputAffix = "dig-40uuazw_22-5-0";
var textInputAndAreaBorderWidth = 1;
var textInputChipsContainer = "dig-40uuazp_22-5-0";
var textInputContainerRecipe = _7a4682({ defaultClassName: "dig-40uuaz4_22-5-0 dig-40uuaz3_22-5-0", variantClassNames: { size: { large: "dig-40uuaz5_22-5-0", medium: "dig-40uuaz6_22-5-0", small: "dig-40uuaz7_22-5-0" }, isInvalid: { true: "dig-40uuaz8_22-5-0" }, disabled: { true: "dig-40uuaz9_22-5-0" }, isTransparent: { true: "dig-40uuaza_22-5-0" }, isTimePicker: { true: "dig-40uuazb_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var textInputInput = "dig-40uuazq_22-5-0";

// ../src/text_fields/text_area.tsx
import { assignInlineVars } from "@vanilla-extract/dynamic";
function getStyleValue(value) {
  return parseInt(value, 10) || 0;
}
var TextAreaResizable = React7.forwardRef(
  ({ rows, style, onChange, _useFieldSizingWhenAvailable = true, className, maxRows, ...rest }, ref) => {
    const hasMultiRows = rows && rows > 1;
    const [useModernFieldSizing, setUseModernFieldSizing] = React7.useState(!hasMultiRows);
    const innerRef = React7.useRef();
    const parentRef = React7.useRef(null);
    const attachRef = createAttachRef(ref, innerRef);
    const shadowRef = React7.useRef(null);
    const calculateTextAreaHeight = React7.useCallback(() => {
      if (!innerRef.current || !shadowRef.current) {
        return "auto";
      }
      const input = innerRef.current;
      const inputShallow = shadowRef.current;
      const computedStyle = window.getComputedStyle(input);
      inputShallow.style.width = computedStyle.width;
      inputShallow.value = "x";
      const singleRowHeight = inputShallow.scrollHeight;
      inputShallow.value = input.value || rest.placeholder || "x";
      if (inputShallow.value.slice(-1) === "\n") {
        inputShallow.value += " ";
      }
      const boxSizing = computedStyle.boxSizing;
      const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
      let finalHeight = Math.max(inputShallow.scrollHeight, singleRowHeight);
      if (boxSizing === "border-box") {
        finalHeight += border;
      } else {
        const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
        finalHeight -= padding;
      }
      return `${finalHeight}px`;
    }, [rest.placeholder]);
    React7.useEffect(() => {
      if (_useFieldSizingWhenAvailable) {
        setUseModernFieldSizing(!hasMultiRows && CSS.supports("field-sizing", "content"));
        return;
      }
      setUseModernFieldSizing(false);
    }, [_useFieldSizingWhenAvailable, hasMultiRows, setUseModernFieldSizing]);
    useResizeObserver(
      parentRef,
      (observerEntry) => {
        if (observerEntry) {
          syncHeight();
        }
      },
      !useModernFieldSizing
    );
    const syncHeight = React7.useCallback(() => {
      if (!useModernFieldSizing && shadowRef.current && innerRef.current) {
        innerRef.current.style.height = calculateTextAreaHeight();
      }
    }, [useModernFieldSizing, calculateTextAreaHeight]);
    const onChangeHandler = (ev) => {
      syncHeight();
      if (onChange) {
        onChange(ev);
      }
    };
    const hasMaxRows = typeof maxRows === "number" && maxRows > 0;
    return /* @__PURE__ */ React7.createElement("div", { ref: parentRef }, /* @__PURE__ */ React7.createElement(
      "textarea",
      {
        className: cls(className, {
          "dig-TextArea--field-sizing": useModernFieldSizing,
          [textAreaFieldSizing]: useModernFieldSizing,
          [textAreaMaxRowsStyle]: hasMaxRows
        }),
        rows,
        ref: attachRef,
        onChange: onChangeHandler,
        style: {
          ...style,
          ...assignInlineVars({
            [textAreaMaxRowsVar]: hasMaxRows ? `calc(${maxRows.toString()}lh + ${textInputAndAreaBorderWidth * 2 + textAreaPaddingBottom + textAreaPaddingTop}px)` : void 0
          })
        },
        ...rest
      }
    ), !useModernFieldSizing && /* @__PURE__ */ React7.createElement(
      "textarea",
      {
        rows,
        ref: shadowRef,
        style: {
          ...style,
          overflow: "hidden",
          position: "absolute",
          visibility: "hidden",
          height: "auto",
          top: 0,
          left: 0,
          transform: "translateZ(0)"
        },
        className,
        ...rest,
        tabIndex: -1,
        "aria-hidden": true,
        id: void 0
      }
    ));
  }
);
TextAreaResizable.displayName = "TextAreaResizable";
var TextArea = React7.forwardRef(
  ({
    size: _size = "medium",
    className,
    isTransparent = false,
    isInvalid = false,
    inverse = false,
    resizable,
    rows = 3,
    "aria-invalid": ariaInvalid,
    maxRows,
    variant = "standard",
    ...rest
  }, ref) => {
    const size = getMigratedComponentSize(_size);
    const fusionInvalid = combineInvalid(isInvalid, ariaInvalid);
    const inverseClassName = useTheme2().getInverseProps().className;
    const effectiveVariant = isTransparent ? "transparent" : variant;
    const cls2 = classNames4(
      "dig-TextArea",
      textAreaRecipe({
        size,
        resizable,
        isInvalid,
        variant: effectiveVariant
      }),
      makeScrollbarClassName({
        borderRadius: sizeMapToBorderRadius[size]
      }),
      `dig-TextArea--${getLegacyComponentSize(size)}`,
      {
        "dig-TextArea--medium": size === "medium",
        "dig-TextArea--isTransparent": effectiveVariant === "transparent",
        "dig-TextArea--isInvalid": !!isInvalid && !rest.disabled,
        "dig-TextArea--resizable": resizable === "both",
        "dig-TextArea--resizableHorizontal": resizable === "horizontal",
        "dig-TextArea--resizableVertical": resizable === "vertical",
        "dig-TextArea--resizableAuto": resizable === "auto",
        [inverseClassName]: inverse
      },
      className
    );
    if (resizable === "auto") {
      return /* @__PURE__ */ React7.createElement(
        TextAreaResizable,
        {
          className: cls2,
          rows,
          ref,
          "aria-invalid": fusionInvalid,
          maxRows,
          ...rest
        }
      );
    }
    return /* @__PURE__ */ React7.createElement("textarea", { className: cls2, rows, ref, "aria-invalid": fusionInvalid, ...rest });
  }
);
TextArea.displayName = "TextArea";

// ../src/text_fields/text_input.tsx
import classNames5 from "classnames";
import * as React8 from "react";
import { UIIcon as UIIcon3, IconContext } from "@dropbox/dig-icons";
import { ClockLine } from "@dropbox/dig-icons/assets";
import { useTheme as useTheme3 } from "@dropbox/dig-foundations";

// ../src/_global/virtual_element_ref.tsx
var createVirtualElementRef = (domRef) => ({
  getBoundingClientRect() {
    return domRef.current ? domRef.current.getBoundingClientRect() : new DOMRect();
  },
  contextElement: domRef.current || void 0
});

// ../src/text_fields/text_input.tsx
var TextInputContainer = React8.forwardRef(
  ({
    /** Type asserted because tsc interprets as string */
    size: _size = "medium",
    className,
    disabled,
    isInvalid,
    inverse,
    onBlur,
    onFocus,
    isTransparent,
    type,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    "aria-invalid": ariaInvalid,
    ...rest
  }, ref) => {
    const [isFocused, setIsFocused] = React8.useState(false);
    const spanRef = React8.useRef(null);
    const size = getMigratedComponentSize(_size);
    React8.useImperativeHandle(ref, () => {
      return createVirtualElementRef(spanRef);
    });
    const inverseClassName = useTheme3().getInverseProps().className;
    const cls2 = classNames5(
      "dig-TextInputContainer",
      `dig-TextInputContainer--${getLegacyComponentSize(size)}`,
      textInputContainerRecipe({
        size,
        isInvalid: !!isInvalid && !disabled,
        disabled,
        isTransparent,
        isTimePicker: type === "time"
      }),
      className,
      {
        "dig-TextInputContainer--medium": size === "medium",
        "dig-TextInputContainer--isFocused": isFocused,
        "dig-TextInputContainer--isInvalid": !!isInvalid && !disabled,
        "dig-TextInputContainer--isTransparent": isTransparent,
        [inverseClassName]: inverse,
        "dig-TextInputContainer--disabled": disabled,
        "dig-TextInputContainer--isTimePicker": type === "time"
      }
    );
    const handleFocus = (e) => {
      setIsFocused(true);
      if (onFocus) {
        onFocus(e);
      }
    };
    const handleBlur = (e) => {
      setIsFocused(false);
      if (onBlur) {
        onBlur(e);
      }
    };
    return /* @__PURE__ */ React8.createElement("span", { className: cls2, onBlur: handleBlur, onFocus: handleFocus, ref: spanRef, ...rest });
  }
);
TextInputContainer.displayName = "TextInput.Container";
var TextInputAccessory = ({ children, position }) => {
  const cls2 = classNames5(
    "dig-TextInputAccessory",
    {
      "dig-TextInputAccessory--start": position === "start",
      "dig-TextInputAccessory--end": position === "end"
    },
    textInputAccessoryRecipe({ position })
  );
  return /* @__PURE__ */ React8.createElement(
    IconContext.Provider,
    {
      value: {
        UIIconOverrides: { isOpticallyAligned: true }
      }
    },
    /* @__PURE__ */ React8.createElement("span", { className: cls2 }, children)
  );
};
TextInputAccessory.displayName = "TextInput.Accessory";
var TextInputChipsContainer = (props) => /* @__PURE__ */ React8.createElement(
  "div",
  {
    className: classNames5(
      "dig-TextInput-chips-container",
      // Note: this `__cluster` is redundant and can be removed
      "dig-TextInput-chips-container__cluster",
      textInputChipsContainer
    )
  },
  props.children
);
var TextInputAffix = (props) => /* @__PURE__ */ React8.createElement("span", { className: classNames5("dig-TextInput-affix", textInputAffix), ...props });
TextInputChipsContainer.displayName = "TextInput.ChipsContainer";
var TextInputInput = React8.forwardRef(
  ({ className, type = "text", ...rest }, ref) => {
    const hasSelection = ["text", "search", "url", "tel", "password"].includes(type);
    const inputRef = React8.createRef();
    React8.useImperativeHandle(ref, () => {
      return {
        focus() {
          if (!inputRef.current) return;
          inputRef.current.focus();
        },
        select() {
          if (!inputRef.current) return;
          inputRef.current.select();
        },
        blur() {
          if (!inputRef.current) return;
          inputRef.current.blur();
        },
        get value() {
          return inputRef.current ? inputRef.current.value : "";
        },
        set value(value) {
          console.warn(
            "Accessing and setting values via the DOM directly is highly discouraged. Please refactor to set your value and pass it down via a React prop instead."
          );
          if (!inputRef.current) return;
          inputRef.current.value = value;
        },
        selectionStart: inputRef.current && hasSelection ? inputRef.current.selectionStart : null,
        selectionEnd: inputRef.current && hasSelection ? inputRef.current.selectionEnd : null,
        selectionDirection: inputRef.current && hasSelection ? inputRef.current.selectionDirection : null,
        setSelectionRange(...args) {
          if (!inputRef.current || !hasSelection) return;
          inputRef.current.setSelectionRange(...args);
        },
        // To be removed
        DEPRECATED_unwrapDOMNode() {
          console.warn("Accessing the DOM node directly is highly discouraged.");
          return inputRef.current;
        }
      };
    });
    const inputCls = classNames5("dig-TextInput-input", textInputInput, className);
    return /* @__PURE__ */ React8.createElement("input", { type, className: inputCls, ref: inputRef, ...rest });
  }
);
TextInputInput.displayName = "TextInput.Input";
var TextInput = React8.forwardRef(
  ({
    size = "standard",
    nativeSize,
    disabled,
    isInvalid,
    inverse,
    withLeftAccessory,
    withRightAccessory,
    isTransparent,
    wrapperProps = {},
    type = "text",
    "aria-invalid": ariaInvalid,
    ...rest
  }, ref) => {
    const containerRef = React8.useRef(null);
    const inputRef = React8.useRef(null);
    const fusionInvalid = combineInvalid(isInvalid, ariaInvalid);
    React8.useImperativeHandle(ref, () => {
      if (!inputRef.current || !containerRef.current) return null;
      inputRef.current.getBoundingClientRect = containerRef.current.getBoundingClientRect;
      inputRef.current.contextElement = containerRef.current.contextElement || void 0;
      return inputRef.current;
    });
    return /* @__PURE__ */ React8.createElement(
      TextInput.Container,
      {
        disabled,
        isInvalid,
        inverse,
        isTransparent,
        size,
        ref: containerRef,
        type,
        ...wrapperProps
      },
      withLeftAccessory && /* @__PURE__ */ React8.createElement(TextInput.Accessory, { position: "start" }, withLeftAccessory),
      type === "time" && /* @__PURE__ */ React8.createElement(TextInput.Accessory, { position: "start" }, /* @__PURE__ */ React8.createElement(UIIcon3, { src: ClockLine })),
      /* @__PURE__ */ React8.createElement(
        TextInput.Input,
        {
          disabled,
          ref: inputRef,
          type,
          "aria-invalid": fusionInvalid,
          size: nativeSize,
          ...rest
        }
      ),
      withRightAccessory && /* @__PURE__ */ React8.createElement(TextInput.Accessory, { position: "end" }, withRightAccessory)
    );
  }
  // Type assertion to enable adding subcomponents as static props below
  // There doesn't seem to be a way to avoid this with current forwardRef typings
  // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
);
TextInput.displayName = "TextInput";
TextInput.Container = TextInputContainer;
TextInput.ChipsContainer = TextInputChipsContainer;
TextInput.Accessory = TextInputAccessory;
TextInput.Input = TextInputInput;
TextInput.Affix = TextInputAffix;
export {
  Select,
  TextArea,
  TextInput,
  TextInputAccessory,
  TextInputAffix,
  TextInputChipsContainer,
  TextInputContainer,
  TextInputInput
};
